import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor() {}

  get(key: string): object | null {
    const value = localStorage.getItem(key);
    if (!value) return null;

    return JSON.parse(value);
  }

  set(key: string, value: object): void {
    const jsonText = JSON.stringify(value);
    localStorage.setItem(key, jsonText);
  }

  remove(key: string): void {
    localStorage.removeItem(key);
  }
}
